export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  genres: string[];
  rating: number;
  votes: number;
  popularity: number;
  poster: string;
  backdrop: string;
  director: string;
  cast: string[];
  duration: number;
  region: string;
  synopsis: string;
  reviewExcerpt: string;
  review: string[];
  tags: string[];
}

export const movies: Movie[] = [
  {
    id: "m1",
    title: "星际远征",
    titleEn: "Interstellar Odyssey",
    year: 2024,
    genres: ["scifi", "drama"],
    rating: 8.7,
    votes: 12480,
    popularity: 98,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20against%20a%20giant%20ringed%20planet%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20dramatic%20volumetric%20light%2C%20high%20detail%20editorial%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m1-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20space%20scene%20with%20a%20spaceship%20approaching%20a%20luminous%20ringed%20planet%2C%20deep%20navy%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20wide%20composition%2C%20high%20detail%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=movie-m1-backdrop-2026&orientation=landscape",
    director: "艾德里安·科尔",
    cast: ["莱昂·哈特", "玛戈·维斯特", "德里克·奥森"],
    duration: 152,
    region: "美国",
    synopsis: "当太阳系边缘的虫洞再度开启，一支由物理学家与退役飞行员组成的远征队踏上未知旅途。他们要在有限的时间里找到人类新的家园，也必须面对时间与亲情之间无法弥合的裂痕。",
    reviewExcerpt: "以宏大的宇宙尺度包裹细腻的亲情内核，视觉与情感同样震撼。",
    review: [
      "《星际远征》最令人惊叹的，是它把最遥远的星系和最私人的情感缝合在了一起。导演用近乎固执的耐心铺设每一处引力与时间的伏笔，让观众在震撼于宇宙奇观的同时，也被一段父女之间的承诺牢牢攥住。",
      "影片的视听语言堪称教科书级别：无声的太空、被拉长的呼吸声、以及每一次穿越虫洞时骤然收紧的音效，都在提醒我们渺小与伟大的并存。演员的表演克制却极具穿透力，尤其是结尾静默的相认段落，几乎没有台词，却让人久久无法平复。",
      "这不是一部只靠特效取胜的科幻片。它真正想说的，是当科学与情感发生冲突时，人类仍然愿意为爱做出非理性的选择。这份温柔，正是它超越同类作品的关键。",
    ],
    tags: ["太空", "亲情", "硬科幻"],
  },
  {
    id: "m2",
    title: "暗夜追凶",
    titleEn: "Dark Night Hunt",
    year: 2023,
    genres: ["action", "mystery"],
    rating: 8.2,
    votes: 9630,
    popularity: 92,
    poster: "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%20of%20a%20detective%20under%20rain%20in%20a%20neon-lit%20alley%2C%20dark%20navy%20and%20amber%20color%20grading%2C%20cinematic%20contrast%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m2-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20distant%20lights%2C%20deep%20navy%20and%20amber%20tones%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m2-backdrop-2026&orientation=landscape",
    director: "诺亚·布莱克",
    cast: ["卡尔·雷恩", "艾琳·福斯特", "汤姆·基廷"],
    duration: 128,
    region: "英国",
    synopsis: "一连串发生在雨夜的悬案把警探雷恩拖入城市的暗面。当他逐渐接近真相，才发现凶手留下的线索，每一条都指向他自己不愿触碰的过去。",
    reviewExcerpt: "雨夜与霓虹交织的犯罪迷宫，节奏张弛有度，反转扎实可信。",
    review: [
      "《暗夜追凶》把经典的警匪追捕拍出了新的呼吸感。导演对雨夜氛围的营造近乎偏执，每一滴落下的雨都在为紧张情绪服务，让整座城市本身成为叙事的参与者。",
      "剧本的聪明之处在于，它没有让反转沦为炫技。每一次真相的揭示，都建立在前面已经埋下的性格与动机之上，观众回头再看时会发现线索一直都在，只是被自己忽略了。",
      "男主角把一个疲惫却不甘放弃的警探演得入木三分。动作戏干净利落，文戏则留足了沉默的空间。这是那种看完会想立刻二刷找细节的作品。",
    ],
    tags: ["犯罪", "反转", "雨夜"],
  },
  {
    id: "m3",
    title: "归途",
    titleEn: "The Long Way Home",
    year: 2024,
    genres: ["drama"],
    rating: 8.5,
    votes: 7240,
    popularity: 84,
    poster: "https://readdy.ai/api/search-image?query=Warm%20drama%20movie%20poster%20of%20a%20lone%20traveler%20walking%20a%20country%20road%20at%20golden%20hour%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20emotional%20cinematic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m3-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Endless%20country%20road%20through%20golden%20fields%20at%20sunset%2C%20warm%20amber%20light%20with%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m3-backdrop-2026&orientation=landscape",
    director: "克拉拉·门罗",
    cast: ["阿尔弗雷德·怀特", "塞西莉亚·格林", "本·卡特"],
    duration: 116,
    region: "美国",
    synopsis: "一位多年未归的中年男人在母亲离世后驾车返乡，沿途遇见的陌生人、旧照片和未寄出的信，逼着他重新梳理自己与家人之间那段沉默的岁月。",
    reviewExcerpt: "克制而温柔的家庭叙事，把告别拍得安静却重若千钧。",
    review: [
      "《归途》是一部几乎没有戏剧性冲突的电影，却处处都是暗涌。导演选择用公路片的外壳，承载一场关于和解与告别的内心旅程，把那些没说出口的话都留在了风景与沉默里。",
      "真正打动人的是它的分寸感。它不煽情，不解释，只是让角色一个又一个地面对自己的遗憾。母亲的旧物、加油站陌生人的一句问候，都成了情绪的引信。",
      "看完以后你会想起自己很久没联系的那个人。这部电影最珍贵的，正是这份让人愿意回头的力量。",
    ],
    tags: ["家庭", "公路", "治愈"],
  },
  {
    id: "m4",
    title: "永恒之约",
    titleEn: "Eternal Vow",
    year: 2023,
    genres: ["romance"],
    rating: 7.9,
    votes: 8120,
    popularity: 80,
    poster: "https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20two%20silhouettes%20holding%20hands%20on%20a%20seaside%20pier%20at%20dusk%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20dreamy%20cinematic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m4-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Seaside%20pier%20at%20dusk%20with%20warm%20amber%20horizon%20and%20deep%20navy%20sea%2C%20romantic%20cinematic%20wide%20composition%2C%20soft%20glow%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m4-backdrop-2026&orientation=landscape",
    director: "伊莎贝尔·罗兰",
    cast: ["卢卡斯·贝尔", "安娜·肖", "保罗·里德"],
    duration: 108,
    region: "法国",
    synopsis: "两个在异乡相识的年轻人在一场意外中约定，无论未来如何变化，每年都要回到最初相遇的海边。多年过去，这个约定成了他们之间最牢固也最脆弱的牵绊。",
    reviewExcerpt: "把爱情的甜与痛都拍进了海风里，安静、细腻、后劲十足。",
    review: [
      "《永恒之约》没有狗血的桥段，而是选择用时间跨度去考验一段感情。导演把大量的情绪交给了海边的光线与两个人的沉默，让观众自己去填补那些未被言说的部分。",
      "男女主的化学反应非常自然，他们争吵时的不甘和重逢时的犹豫都被精准地捕捉。影片对'约定'这个意象的处理尤其动人——它既是承诺，也是一种温柔的束缚。",
      "如果你相信爱情是被时间打磨出来的，这部电影会让你在散场后很久都舍不得离开座位。",
    ],
    tags: ["纯爱", "约定", "海边"],
  },
  {
    id: "m5",
    title: "迷雾之城",
    titleEn: "City of Mist",
    year: 2024,
    genres: ["mystery", "drama"],
    rating: 8.1,
    votes: 6890,
    popularity: 86,
    poster: "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20movie%20poster%20of%20a%20foggy%20metropolis%20skyline%20with%20a%20lone%20figure%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20moody%20cinematic%20light%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m5-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=A%20fog-covered%20city%20skyline%20at%20blue%20hour%20with%20scattered%20amber%20lights%2C%20deep%20navy%20tones%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m5-backdrop-2026&orientation=landscape",
    director: "马丁·维拉",
    cast: ["奥利维亚·丘", "拉斐尔·桑", "格蕾丝·金"],
    duration: 134,
    region: "美国",
    synopsis: "记者丘在一次例行调查中，发现整座城市都笼罩在一场看不见的集体谎言里。随着迷雾一层层散开，她不得不面对一个更可怕的真相：有些记忆，是被所有人共同选择遗忘的。",
    reviewExcerpt: "气氛营造出色，把一座城市的集体失忆拍得令人脊背发凉。",
    review: [
      "《迷雾之城》最出色的地方在于它的'雾'不仅是视觉元素，更是叙事隐喻。导演用潮湿、朦胧的画面不断模糊真实与谎言的边界，让人始终处于不安之中。",
      "影片没有给出廉价的解答，而是把选择权交给了观众。真相被揭开的那一刻并不痛快，反而带着一种沉重的清醒，这正是它高于一般悬疑片的地方。",
      "剪辑与配乐配合默契，尤其是中段那场没有对白的追查戏，全靠环境音和光影推进，令人印象深刻。",
    ],
    tags: ["心理", "阴谋", "氛围"],
  },
  {
    id: "m6",
    title: "雷霆突击",
    titleEn: "Thunder Strike",
    year: 2023,
    genres: ["action"],
    rating: 7.6,
    votes: 10240,
    popularity: 88,
    poster: "https://readdy.ai/api/search-image?query=High-octane%20action%20movie%20poster%20of%20a%20special%20forces%20soldier%20silhouette%20in%20smoke%20and%20sparks%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20dramatic%20lighting%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m6-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Explosive%20action%20scene%20with%20sparks%20and%20smoke%20in%20an%20urban%20setting%2C%20deep%20navy%20and%20amber%20firelight%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m6-backdrop-2026&orientation=landscape",
    director: "雷·多诺万",
    cast: ["杰克·哈珀", "米拉·索恩", "戴维斯·李"],
    duration: 122,
    region: "美国",
    synopsis: "一支被解散多年的精英小队因一次人质危机被迫重组。他们必须在七十二小时内完成一场几乎不可能的任务，而真正的敌人或许就藏在队伍内部。",
    reviewExcerpt: "枪火与爆破调度凌厉，动作片迷要的就是这份干脆利落的爽感。",
    review: [
      "《雷霆突击》把'爽'字做得很纯粹。动作场面的调度干净利落，几乎没有多余的镜头语言，每一次交火都清晰可辨，让观众能真正跟上战斗的节奏。",
      "虽然剧情走的是经典的团队重组路线，但人物之间的信任危机处理得颇为扎实，让动作戏有了情感支点，而不只是无脑的轰炸。",
      "如果你只想要一场酣畅淋漓的视听体验，这部片子绝对不会让你失望。",
    ],
    tags: ["特种兵", "爆破", "爽片"],
  },
  {
    id: "m7",
    title: "心之所向",
    titleEn: "Where the Heart Goes",
    year: 2024,
    genres: ["romance", "drama"],
    rating: 8.0,
    votes: 5460,
    popularity: 74,
    poster: "https://readdy.ai/api/search-image?query=Gentle%20romance%20drama%20movie%20poster%20of%20a%20woman%20looking%20out%20a%20rainy%20window%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20warm%20melancholic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m7-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cozy%20rainy%20evening%20city%20window%20view%20with%20amber%20warm%20lamp%20light%2C%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m7-backdrop-2026&orientation=landscape",
    director: "索菲亚·阮",
    cast: ["艾玛·克莱恩", "丹尼尔·罗", "露西·亚当斯"],
    duration: 112,
    region: "美国",
    synopsis: "一位在大城市打拼多年的钢琴老师，在事业与感情的十字路口回到故乡。旧日的乐谱、熟悉的街角，以及那个一直没走远的人，让她重新思考什么才是自己真正想要的。",
    reviewExcerpt: "细腻描绘成年人的选择困境，温柔中带着清醒的现实感。",
    review: [
      "《心之所向》讲的不是轰轰烈烈的爱情，而是成年人站在十字路口时的犹豫与勇气。影片对'选择'这个主题的探讨十分真诚，没有给出标准答案，而是尊重每一种可能的活法。",
      "女主的表演层次丰富，从都市的疲惫到故乡的松弛，情绪的过渡自然可信。配乐以钢琴为主线，与人物身份呼应，成为叙事的一部分。",
      "这是一部适合在一个安静的周末午后独自观看的电影，看完会想给自己泡杯茶，安静一会儿。",
    ],
    tags: ["都市", "选择", "治愈"],
  },
  {
    id: "m8",
    title: "机械黎明",
    titleEn: "Mechanical Dawn",
    year: 2023,
    genres: ["scifi", "action"],
    rating: 8.4,
    votes: 11260,
    popularity: 94,
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20action%20movie%20poster%20of%20a%20humanoid%20robot%20face%20half%20revealing%20circuits%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20futuristic%20dramatic%20lighting%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m8-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Futuristic%20city%20at%20dawn%20with%20flying%20vehicles%20and%20glowing%20amber%20energy%20lines%2C%20deep%20navy%20tones%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m8-backdrop-2026&orientation=landscape",
    director: "维克多·林",
    cast: ["艾伦·凯", "娜奥米·郑", "罗伯特·冯"],
    duration: 140,
    region: "美国",
    synopsis: "当第一台拥有自我意识的服务型机器人觉醒，人类与机械之间脆弱的和平被彻底打破。一名工程师必须在抵制动荡与保护'它'之间做出抉择，而这个选择将决定两个物种的未来。",
    reviewExcerpt: "在爆炸与追逐之外，真正拷问的是'何为生命'这个古老命题。",
    review: [
      "《机械黎明》是一部野心勃勃的作品。它用高强度的动作场面吸引观众入场，却在深处追问一个哲学问题：当机械拥有了情感，我们是否还配得上'人类'这个称呼？",
      "影片对人工智能的刻画摆脱了简单的正邪对立，机器人角色的成长曲线细腻而可信，让观众很难对它产生单纯的敌意。这种复杂性正是它最迷人的地方。",
      "视觉设计极具未来感，动作戏与思辨部分的比例拿捏得当，既有商业片的娱乐性，也保留了作者表达的锋芒。",
    ],
    tags: ["人工智能", "觉醒", "未来"],
  },
  {
    id: "m9",
    title: "沉默证词",
    titleEn: "Silent Testimony",
    year: 2024,
    genres: ["mystery", "drama"],
    rating: 8.3,
    votes: 5980,
    popularity: 78,
    poster: "https://readdy.ai/api/search-image?query=Legal%20drama%20movie%20poster%20of%20an%20empty%20courtroom%20with%20single%20spotlight%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20tense%20atmosphere%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m9-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Dramatic%20dim%20courtroom%20interior%20with%20warm%20amber%20light%20through%20tall%20windows%2C%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m9-backdrop-2026&orientation=landscape",
    director: "海伦·巴斯",
    cast: ["詹姆斯·诺", "克莱尔·邓", "山姆·奥尔森"],
    duration: 126,
    region: "英国",
    synopsis: "一桩看似铁证如山的案件，因为一名始终不肯开口的关键证人而陷入僵局。年轻律师在追查中逐渐发现，沉默的背后藏着比谎言更沉重的东西。",
    reviewExcerpt: "法庭戏张力十足，把'沉默'本身拍成了一种震耳欲聋的表达。",
    review: [
      "《沉默证词》把舞台集中在法庭与审讯室这些有限空间里，却爆发出了惊人的能量。剧本的对白锋利好斗，每一个回合都像一场精心计算的博弈。",
      "影片最聪明的地方，是让'沉默'成为核心悬念。为什么证人拒绝开口？当答案揭晓时，观众才意识到自己一直忽略了最简单也最残酷的可能性。",
      "表演是这部片子的灵魂，几位演员在有限的动作中传递出巨大情绪。这是一部值得反复推敲台词的作品。",
    ],
    tags: ["法庭", "推理", "人性"],
  },
  {
    id: "m10",
    title: "荒原余生",
    titleEn: "Wasteland Survivors",
    year: 2022,
    genres: ["action", "drama"],
    rating: 7.8,
    votes: 8760,
    popularity: 76,
    poster: "https://readdy.ai/api/search-image?query=Post-apocalyptic%20movie%20poster%20of%20a%20lone%20survivor%20walking%20a%20dusty%20wasteland%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20gritty%20cinematic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m10-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vast%20dusty%20wasteland%20at%20dusk%20with%20abandoned%20wreckage%2C%20warm%20amber%20horizon%20and%20deep%20navy%20sky%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m10-backdrop-2026&orientation=landscape",
    director: "格雷格·索耶",
    cast: ["布莱恩·科尔", "娜丁·霍", "埃里克·杨"],
    duration: 130,
    region: "美国",
    synopsis: "在一场灾难之后，世界只剩下无尽的荒原。一位父亲带着女儿穿越废土寻找传说中的避难所，而比恶劣环境更危险的，是那些同样在为生存挣扎的人。",
    reviewExcerpt: "废土题材外壳下，是一段关于守护与希望的父女旅程。",
    review: [
      "《荒原余生》没有把重心放在末日奇观上，而是聚焦于两个人在极端环境中的相互依靠。这份克制让它在一众末世题材中显得格外真诚。",
      "影片对环境细节的刻画令人信服，干裂的土地、稀缺的水源，都在无形中放大了生存的压力。父女之间的对话不多，却每一句都有分量。",
      "它想说的其实很简单：只要还有想守护的人，荒原就仍有意义。",
    ],
    tags: ["末日", "父女", "生存"],
  },
  {
    id: "m11",
    title: "时光信笺",
    titleEn: "Letters in Time",
    year: 2022,
    genres: ["romance", "drama"],
    rating: 7.5,
    votes: 4320,
    popularity: 66,
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20romance%20movie%20poster%20of%20old%20letters%20and%20a%20vintage%20desk%20lamp%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20warm%20nostalgic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m11-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Old%20wooden%20desk%20with%20scattered%20handwritten%20letters%20and%20warm%20amber%20lamp%20light%2C%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m11-backdrop-2026&orientation=landscape",
    director: "艾米丽·福特",
    cast: ["亨利·吴", "索菲·陈", "马克·贝尔"],
    duration: 104,
    region: "美国",
    synopsis: "整理祖母遗物时，孙女发现了一迭从未寄出的信，收信人是一个她从未听过的名字。循着信中的地址，她踏上了一段跨越半个世纪的寻找之旅。",
    reviewExcerpt: "用一迭旧信串起两代人的爱情，温吞却动人。",
    review: [
      "《时光信笺》采用双时间线叙事，将祖母年轻时的爱情与孙女的当下寻找交织在一起。影片节奏舒缓，却始终有一股温柔的牵引力。",
      "信件作为叙事载体被运用得非常巧妙，文字与画面的呼应让情感层层递进。虽然没有激烈的冲突，但那种'错过'的遗憾足以让人揪心。",
      "如果你喜欢慢慢讲故事的电影，这部会很对你的胃口。",
    ],
    tags: ["书信", "跨越时空", "怀旧"],
  },
  {
    id: "m12",
    title: "虫洞边缘",
    titleEn: "Edge of the Wormhole",
    year: 2024,
    genres: ["scifi", "mystery"],
    rating: 8.6,
    votes: 9100,
    popularity: 90,
    poster: "https://readdy.ai/api/search-image?query=Sci-fi%20mystery%20movie%20poster%20of%20a%20glowing%20spiral%20wormhole%20in%20deep%20space%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20hypnotic%20cinematic%20light%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m12-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Giant%20luminous%20spiral%20wormhole%20surrounded%20by%20stars%2C%20amber%20and%20deep%20navy%20gradients%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m12-backdrop-2026&orientation=landscape",
    director: "陈立维",
    cast: ["凯特·莫里森", "安德烈·波", "蕾切尔·唐"],
    duration: 145,
    region: "美国",
    synopsis: "科研站收到一段来自虫洞另一端的重复信号，内容竟是被加密的个人记忆。当科学家们试图解码，他们发现信号的主人，可能正是他们中的某个人。",
    reviewExcerpt: "把高概念科幻与心理惊悚熔于一炉，悬念层层递进直至最后一刻。",
    review: [
      "《虫洞边缘》最大的魅力在于它同时满足了硬核科幻迷和悬疑爱好者的期待。物理设定严谨可信，而围绕'记忆信号'展开的谜题则牢牢抓住了观众的注意力。",
      "影片在视觉上非常克制，大量使用冷调的深空和暖调的信号光形成对比，营造出一种既壮丽又不安的氛围。",
      "结局的开放式处理引发大量讨论，这恰恰证明了它成功地让观众在散场后仍然思考不息。这是一部值得反复观看、逐帧分析的作品。",
    ],
    tags: ["虫洞", "记忆", "高概念"],
  },
  {
    id: "m13",
    title: "最后的证人",
    titleEn: "The Last Witness",
    year: 2023,
    genres: ["mystery", "action"],
    rating: 8.0,
    votes: 6640,
    popularity: 79,
    poster: "https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%20of%20a%20man%20running%20through%20a%20dark%20parking%20garage%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20tense%20cinematic%20lighting%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m13-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Dim%20underground%20parking%20garage%20with%20amber%20emergency%20lights%20and%20deep%20navy%20shadows%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m13-backdrop-2026&orientation=landscape",
    director: "保罗·哈迪",
    cast: ["肖恩·布莱", "伊娃·隆", "克里斯·戴"],
    duration: 118,
    region: "美国",
    synopsis: "一名普通会计意外目睹了一场交易，成为警方唯一的关键证人。在保护性监禁的日子里，他逐渐意识到，比起外面的杀手，身边的人才更让他无法安心。",
    reviewExcerpt: "猫鼠游戏节奏紧凑，全程让人屏住呼吸。",
    review: [
      "《最后的证人》是一部非常称职的类型片。它深知自己的优势在于节奏，于是毫不拖泥带水地推进剧情，让观众始终保持高度紧张。",
      "影片对'被保护者'与'保护者'之间关系的刻画颇有意思，信任的建立与瓦解构成了主要张力。几次反转虽然不算新鲜，但执行得足够扎实。",
      "作为一部周末放松观看的悬疑片，它的完成度相当高。",
    ],
    tags: ["证人", "追逃", "紧张"],
  },
  {
    id: "m14",
    title: "破晓行动",
    titleEn: "Dawn Operation",
    year: 2024,
    genres: ["action"],
    rating: 7.7,
    votes: 7120,
    popularity: 82,
    poster: "https://readdy.ai/api/search-image?query=Action%20movie%20poster%20of%20a%20helicopter%20silhouette%20against%20a%20dawn%20sky%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20dramatic%20cinematic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m14-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Helicopters%20flying%20over%20a%20coastal%20city%20at%20dawn%20with%20amber%20sunrise%20and%20deep%20navy%20sea%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m14-backdrop-2026&orientation=landscape",
    director: "马克·斯坦",
    cast: ["瑞恩·科", "莉娜·瓦", "奥斯汀·里"],
    duration: 120,
    region: "美国",
    synopsis: "一场针对沿海城市的突袭在黎明打响。被推上前线的年轻指挥官，必须在命令与良知之间做出判断，而每一个决定都关乎身后无数人的生死。",
    reviewExcerpt: "场面调度大气，战争与人性之间的撕扯令人动容。",
    review: [
      "《破晓行动》在动作场面上舍得投入，海陆空多线并进的调度颇具大片格局。但让它区别于普通战争片的是，它始终没有忘记镜头后面是一个个具体的人。",
      "年轻指挥官的心理刻画是影片的支点，他从服从到质疑的转变推动了整部电影的情感走向。",
      "视听效果出色，适合在大银幕上观看。",
    ],
    tags: ["战争", "指挥", "抉择"],
  },
  {
    id: "m15",
    title: "静默海洋",
    titleEn: "The Silent Ocean",
    year: 2023,
    genres: ["drama"],
    rating: 8.8,
    votes: 4880,
    popularity: 72,
    poster: "https://readdy.ai/api/search-image?query=Art-house%20drama%20movie%20poster%20of%20a%20solitary%20lighthouse%20by%20the%20sea%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20serene%20melancholic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m15-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Solitary%20lighthouse%20on%20a%20rocky%20coast%20at%20dusk%20with%20amber%20beacon%20and%20deep%20navy%20sea%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m15-backdrop-2026&orientation=landscape",
    director: "安娜·贝洛",
    cast: ["伊莎贝尔·缪", "格奥尔格·诺", "福田·优"],
    duration: 138,
    region: "法国",
    synopsis: "一位失去听觉的灯塔守护者，在孤寂的海岸线上与大海相伴数十年。当一位前来采访的年轻记者到来，两个陌生人用纸笔展开了一场关于孤独与存在的漫长对话。",
    reviewExcerpt: "极简叙事下的深沉之作，安静得能听见时间的流逝。",
    review: [
      "《静默海洋》是一部需要耐心的电影，它会用缓慢的节奏筛掉浮躁的观众，但留下来的人会收获一次近乎冥想式的观影体验。",
      "影片对声音的处理是天才级别的。因为主角失聪，导演大量运用主观音效与画外静默，让观众得以进入一个完全不同的感知世界。",
      "这是那种艺术性与情感深度兼具的作品，值得被反复讨论。它的安静，反而是最响亮的声音。",
    ],
    tags: ["文艺", "孤独", "声音设计"],
  },
  {
    id: "m16",
    title: "幻梦乐园",
    titleEn: "Dreamland Park",
    year: 2024,
    genres: ["animation", "scifi"],
    rating: 8.2,
    votes: 8560,
    popularity: 85,
    poster: "https://readdy.ai/api/search-image?query=Vibrant%20animated%20movie%20poster%20of%20a%20whimsical%20fantasy%20theme%20park%20at%20night%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20magical%20cinematic%20glow%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m16-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20theme%20park%20at%20night%20with%20glowing%20amber%20lights%20and%20deep%20navy%20sky%2C%20magical%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m16-backdrop-2026&orientation=landscape",
    director: "周慕白",
    cast: ["配音：小林遥", "配音：大卫·陈", "配音：艾米·罗"],
    duration: 98,
    region: "美国",
    synopsis: "在一座只在夜晚开放的奇幻乐园里，每个孩子都能实现一个愿望。但当一个小女孩许下了'让妈妈回来'的愿望，乐园的规则开始失控，她必须学会放下才能让一切回归平静。",
    reviewExcerpt: "画面瑰丽，故事温暖，是全家人都能一起看的动人动画。",
    review: [
      "《幻梦乐园》的视觉设计令人惊叹，每一帧都像是会发光的插画。但比画面更打动人的，是它对'失去'与'放下'这个沉重主题的温柔处理。",
      "影片没有回避悲伤，而是告诉孩子：愿望不总是要被实现，学会接受才是成长的开始。这种诚实让它在同类型动画中脱颖而出。",
      "配乐同样出色，主题曲在片尾响起时，很多观众都忍不住红了眼眶。",
    ],
    tags: ["合家欢", "奇幻", "成长"],
  },
  {
    id: "m17",
    title: "疯狂假期",
    titleEn: "Crazy Holiday",
    year: 2024,
    genres: ["comedy"],
    rating: 7.4,
    votes: 5320,
    popularity: 70,
    poster: "https://readdy.ai/api/search-image?query=Colorful%20comedy%20movie%20poster%20of%20a%20chaotic%20family%20road%20trip%20in%20a%20vintage%20car%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20playful%20cinematic%20mood%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m17-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Vintage%20car%20driving%20on%20a%20scenic%20mountain%20road%20with%20warm%20amber%20sunset%20and%20deep%20navy%20shadows%2C%20playful%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m17-backdrop-2026&orientation=landscape",
    director: "托尼·格雷",
    cast: ["史蒂夫·罗", "米兰达·凯", "乔什·比"],
    duration: 102,
    region: "美国",
    synopsis: "一个状况百出的家庭决定用一场公路旅行修复彼此的关系，结果从出发的第一分钟起就麻烦不断。爆胎、迷路、误会接踵而至，笑声背后却悄悄藏着和解。",
    reviewExcerpt: "笑料密集又不过火，笑完之后还有一点暖。",
    review: [
      "《疯狂假期》深谙喜剧的节奏之道，笑料铺陈自然，不会让人感到刻意。一家人的拌嘴真实得就像发生在自己家里。",
      "难得的是，影片在搞笑之外还留了一条温情的暗线。当误会解开的那一刻，观众会发现之前所有的荒诞都是为了让这场和解更有分量。",
      "适合全家人一起观看的轻松之选。",
    ],
    tags: ["家庭", "公路", "爆笑"],
  },
  {
    id: "m18",
    title: "暗影庄园",
    titleEn: "Manor of Shadows",
    year: 2023,
    genres: ["horror", "mystery"],
    rating: 7.3,
    votes: 4680,
    popularity: 68,
    poster: "https://readdy.ai/api/search-image?query=Gothic%20horror%20movie%20poster%20of%20a%20dark%20manor%20silhouette%20under%20a%20stormy%20sky%2C%20deep%20navy%20and%20amber%20color%20grading%2C%20eerie%20cinematic%20lighting%2C%20high%20detail%20illustration%2C%20no%20text&width=600&height=900&seq=movie-m18-poster-2026&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Abandoned%20gothic%20manor%20on%20a%20hill%20under%20a%20stormy%20night%20sky%20with%20faint%20amber%20window%20light%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=movie-m18-backdrop-2026&orientation=landscape",
    director: "罗莎·维尔",
    cast: ["海伦·马", "伊桑·特", "凯拉·布"],
    duration: 106,
    region: "英国",
    synopsis: "一群年轻人为了拍摄灵异纪录片闯入一座废弃庄园，却发现自己逐渐被困在庄园不断重复的夜晚里。想要离开，他们必须先弄清楚这座房子到底在等待什么。",
    reviewExcerpt: "不靠jump scare，靠氛围与规则包裹出持续的心理压迫。",
    review: [
      "《暗影庄园》借鉴了经典的'困于时间循环'设定，并把它与哥特式恐怖完美结合。影片很少使用突然的惊吓，而是通过环境的细节与规则的逐步揭示来积累恐惧。",
      "庄园本身像一个有生命的角色，每一个房间都藏着信息。观众会不自觉地跟着主角一起寻找规律，这种参与感大大增强了代入感。",
      "对于喜欢慢热型心理恐怖的观众来说，这是一部不会失望的作品。",
    ],
    tags: ["哥特", "循环", "心理恐怖"],
  },
];

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((m) => m.id === id);

export const getMoviesByGenre = (genre: string): Movie[] =>
  movies.filter((m) => m.genres.includes(genre));